import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, ReturnTimeZone } from '../../helpers';
import Message from '../Common/Message/Message';
import moment from 'moment-timezone';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import { StatusBar } from '@uppy/react';
import { DragDrop } from '@uppy/react';
import '@uppy/core/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import '@uppy/status-bar/dist/style.css';
import en from './locales/en.json';
import fr from './locales/fr.json';

import './Upload.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const uppyVirtual = Uppy({
    debug: true,
    restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ['video/*']
    },
});

const uppyVOD = Uppy({
    debug: true,
    restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ['video/*']
    },
});

class Upload extends Component {
	constructor(props) {
        super(props);
        this.state = {
            event: {},
            event_type: '',
            canUpload: true,
            message: {
                title: '',
                content: '',
                type: ''
            },
            token: '',
            virtualPoster: {},
            vod: {},
            isVirtualPosterUploading: false,
            isVODUploading: false,
            virtualPosterInfo: {},
            vodInfo: {},
            canUploadEventVideo: true,
            isShowUploadMessage: false,
        };
    }
    
    componentDidMount() {
        // if has event_id, box office and no needed for token
        if (this.props.routeProps.match.params.event_id) {
            if (!this.props.user.role) {
                this.setMessage('Sorry!', 'You need to be logged in to upload a video using this URL.', 'error');
            } else {
                this.getActiveEvent(this.props.routeProps.match.params.event_id);
            }
        } else {
            if(this.props.routeProps.location.search){
                
                this.setState({ token: this.props.routeProps.location.search.split('=')[1].split('&')[0] });
                this.getActiveEvent(this.props.routeProps.location.search.split('=')[2]);
            } else {
                this.setMessage(window.general_strings.msg.oops, 'Your token is invalid', 'error');
                this.setState({
                    canUpload: false,
                });
            }
        }
        

        // Uppy
        uppyVirtual.on('file-added', (file) => {
            console.log('Added file', file)
            
            if (file.size/1000000 <= 50) {
                this.setState({
                    virtualPoster: file,
                });
            } else {
                this.setMessage(window.general_strings.msg.oops, 'File limit is 50Mb.', 'error');
                this.setState({
                    virtualPoster: {},
                    isVirtualPosterUploading: false,
                });
                uppyVirtual.removeFile(file.id);
            }
        });

        uppyVirtual.on('file-removed', (file) => {
            console.log('Remove file', file)
            this.setState({
                virtualPoster: {},
                isVirtualPosterUploading: false,
            });
        });

        uppyVirtual.on('complete', result => {
            console.log('successful files:', result.successful)
            console.log('failed files:', result.failed);

            if (result.successful.length > 0) {
                this.setState({
                    virtualPoster: {},
                    isVirtualPosterUploading: false,
                });
                let message = `Upload of ${result.successful[0].name} has been completed.` + strings.success;
                this.setMessage('Success!', message, 'success');
            }

            if (result.failed.length > 0) {
                this.setMessage('Error', result.failed.error, 'error');
            }
        });

        // Uppy
        uppyVOD.on('file-added', (file) => {
            console.log('Added file', file)
            this.setState({
                vod: file,
            });
        });

        uppyVOD.on('file-removed', (file) => {
            console.log('Remove file', file)
            this.setState({
                vod: {},
                isVODUploading: false,
            });
        });

        uppyVOD.on('complete', result => {
            console.log('successful files:', result.successful);
            console.log('failed files:', result.failed);

            if (result.successful.length > 0) {
                this.setState({
                    vod: {},
                    isVODUploading: false,
                });
            }
            let message = `Upload of ${result.successful[0].name} has been completed.` + strings.success;
            this.setMessage('Success!', message, 'success');

            if (result.failed.length > 0) {
                this.setMessage('Error', result.failed[0].error, 'error');
            }
        });
    }

    getActiveEvent = (event_id) => {
        this.setMessage('', '', 'loading');

        // Load Event
        const getEvent = async () => {
			try {
                // Get client events
                const eventResponse = await get_event();
                console.log('eventResponse', eventResponse);
                
                this.setState({
                    event: eventResponse.data.event,
                    event_type: eventResponse.data.event.event_type,
                });
                this.setMessage('', '', '');

                this.checkIfAllowToUpload();
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        };

        async function get_event() {
            return await ApiRequest(`/events/public/${event_id}`, {
                method: 'GET'
            });
        }

        getEvent();
    }

    checkIfAllowToUpload = () => {
        const timezone = ReturnTimeZone(this.state.event.venue.timezone || 'EST');
        const localUTC = moment().utc();
        const event_dates = this.state.event.event_dates;
        let canUpload = true;

        for (let i = 0; i < event_dates.length; i++) {
            let timeStringEvent = event_dates[i].event_datetime_local.substring(0, 16).replace('T', ' ');
            let venueDateTimeUTCEvent = moment.tz(timeStringEvent, timezone).utc();
            //console.log(moment.duration(venueDateTimeUTCEvent.diff(localUTC)).asMinutes())
            let is4hBefore = moment.duration(venueDateTimeUTCEvent.diff(localUTC)).asMinutes() < 240 && moment.duration(venueDateTimeUTCEvent.diff(localUTC)).asMinutes() > 0;
            canUpload = !is4hBefore;
            if (is4hBefore) {
                break;
            }
        }

        this.setState({
            canUploadEventVideo: canUpload,
        });
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
    
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    
        const i = Math.floor(Math.log(bytes) / Math.log(k));
    
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    uploadVirtualPoster = () => {
        this.setState({
            isVirtualPosterUploading: true,
        });
        
        const virtualPoster = this.state.virtualPoster;

        // if Box Office
        if (this.props.user.role) {
            const event_id = this.state.event.id;

            const createVideo = async () => {
                try {
                    const createResponse = await create_video(event_id);
                    console.log('createResponse', createResponse);  
                
                    if (createResponse.data.vimeo_upload_url) {
                        this.uploadVideo('video-poster', createResponse.data.vimeo_upload_url)
                        this.setState({
                            virtualPosterInfo: createResponse.data
                        });
                    }

                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function create_video(event_id) {
                return await ApiRequest(`/box-office/video/upload/start`, {
                    method: 'POST',
                    data: {
                        event_id: parseInt(event_id),
                        type: 'video-poster',
                        size: virtualPoster.size,
                    }
                });
            }

            const getVideoStatus = async () => {
                try {
                    // Get client events
                    const statusResponse = await get_status(event_id);
                    console.log('statusResponse', statusResponse); 
                    
                    // if url doesn't exist, create the video
                    // if size is not the same as before, create a new video
                    if (statusResponse.data.vimeo_upload_url && statusResponse.data.vimeo_upload_size === virtualPoster.size) {
                        uppyVirtual.use(Tus, { 
                            uploadUrl: statusResponse.data.vimeo_upload_url,
                            resume: true,
                            autoRetry: true,
                            retryDelays: [0, 1000, 3000, 5000],
                        });
                        uppyVirtual.upload();
                        
                        this.setState({
                           virtualPosterInfo: statusResponse.data
                        });
                    } else {
                        createVideo();
                    }
                
                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function get_status(event_id) {
                return await ApiRequest(`/box-office/video/upload/status?event_id=${event_id}&type=video-poster`, {
                    method: 'GET',
                });
            }

            getVideoStatus();
        } else {
            const token = this.state.token;

            console.log(token);
            
            // Load Event
            const createVideo = async () => {
                try {
                    // Get client events
                    const createResponse = await create_video();
                    console.log('createResponse', createResponse);  

                    if (createResponse.data.vimeo_upload_url) {
                        this.uploadVideo('video-poster', createResponse.data.vimeo_upload_url)
                        this.setState({
                            virtualPosterInfo: createResponse.data
                        });
                    }
                
                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function create_video() {
                return await ApiRequest(`/video/upload/start`, {
                    method: 'POST',
                    data: {
                        upload_token: token,
                        type: 'video-poster',
                        size: virtualPoster.size,
                    }
                });
            }

            const getVideoStatus = async () => {
                try {
                    const statusResponse = await get_status(token);
                    console.log('statusResponse', statusResponse);  
                
                    // if url doesn't exist, create the video
                    // if size is not the same as before, create a new video
                    if (statusResponse.data.vimeo_upload_url && statusResponse.data.vimeo_upload_size === virtualPoster.size) {
                        uppyVirtual.use(Tus, { 
                            uploadUrl: statusResponse.data.vimeo_upload_url,
                            resume: true,
                            autoRetry: true,
                            retryDelays: [0, 1000, 3000, 5000],
                        });
                        uppyVirtual.upload();
                        
                        this.setState({
                           virtualPosterInfo: statusResponse.data
                        });
                    } else {
                        console.log('create?')
                        createVideo();
                    }

                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function get_status(token) {
                return await ApiRequest(`/video/upload/status?upload_token=${token}&type=video-poster`, {
                    method: 'GET',
                });
            }

            getVideoStatus();
        }
    }

    removeVirtualPoster = (id) => {
        uppyVirtual.removeFile(id);
        this.setState({
            virtualPoster: {},
            isVirtualPosterUploading: false,
        });
    }

    renderVirtualPoster = () => {
        if (!this.state.virtualPoster.name) {
            return (
                <React.Fragment>
                    <DragDrop
                        uppy={uppyVirtual}
                        locale={{
                            strings: {
                                // Text to show on the droppable area.
                                // `%{browse}` is replaced with a link that opens the system file selection dialog.
                                dropHereOr: 'Drop virtual poster here or %{browse}',
                                // Used as the label for the link that opens the system file selection dialog.
                                browse: 'browse'
                            }
                        }}
                    />
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="showtix-upload-item">
                        <div className="showtix-upload-item__name">
                            <button
                                className="showtix-upload-item__remove"
                                onClick={() => this.removeVirtualPoster(this.state.virtualPoster.id)}
                                disabled={this.state.isVirtualPosterUploading}
                            >
                                &times;
                            </button>
                            {this.state.virtualPoster.name} - {this.formatBytes(this.state.virtualPoster.size)}
                        </div>
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={() => this.uploadVirtualPoster()}
                            disabled={this.state.isVirtualPosterUploading}
                        >
                            Upload
                        </button>
                    </div>
                    <ProgressBar
                        uppy={uppyVirtual}
                        fixed
                        hideAfterFinish
                    />
                    <StatusBar
                        uppy={uppyVirtual}
                        hideUploadButton
                        hideAfterFinish={false}
                        showProgressDetails
                    />
                </React.Fragment>
            );
        }
    }

    uploadVideo = (type, url) => {
        if (type === 'vod') {
            uppyVOD.use(Tus, { 
                uploadUrl: url,
                resume: true,
                autoRetry: true,
                retryDelays: [0, 1000, 3000, 5000],
            });
            uppyVOD.upload();
        } else {
            uppyVirtual.use(Tus, { 
                uploadUrl: url,
                resume: true,
                autoRetry: true,
                retryDelays: [0, 1000, 3000, 5000],
            });
            uppyVirtual.upload();
        }
    }

    uploadVOD = () => {
        this.setState({
            isVODUploading: true,
            isShowUploadMessage: true,
        });
        
        const vod = this.state.vod;

        // if Box Office
        if (this.props.user.role) {
            const event_date_id = this.state.event.event_dates[0].id;
            const event_type = this.state.event.event_type;
            const event_id = this.state.event.id;

            const createVideo = async () => {
                try {
                    const createResponse = await create_video(event_date_id, event_id);
                    console.log('createResponse', createResponse);  
                
                    this.setState({
                        isShowUploadMessage: false,
                    });
                    if (createResponse.data.vimeo_upload_url) {
                        this.uploadVideo('vod', createResponse.data.vimeo_upload_url)
                        this.setState({
                            vodInfo: createResponse.data
                        });
                    }

                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function create_video(event_date_id, event_id) {
                if (event_type === 'Video On Demand') {
                    return await ApiRequest(`/box-office/video/upload/start`, {
                        method: 'POST',
                        data: {
                            event_date_id: parseInt(event_date_id),
                            type: 'vod',
                            size: vod.size,
                        }
                    });
                } else {
                    return await ApiRequest(`/box-office/video/upload/start`, {
                        method: 'POST',
                        data: {
                            event_id: parseInt(event_id),
                            type: 'scheduled-upload',
                            size: vod.size,
                        }
                    });
                }
            }

            const getVideoStatus = async () => {
                try {
                    // Get client events
                    const statusResponse = await get_status(event_date_id);
                    console.log('statusResponse', statusResponse); 
                    
                    // if url doesn't exist, create the video
                    // if size is not the same as before, create a new video

                    console.log('statusResponse.data.vimeo_upload_size', statusResponse.data.vimeo_upload_size)
                    console.log('vod.size', vod.size)
                    if (statusResponse.data.vimeo_upload_url && statusResponse.data.vimeo_upload_size === vod.size) {
                        uppyVOD.use(Tus, { 
                            uploadUrl: statusResponse.data.vimeo_upload_url,
                            resume: true,
                            autoRetry: true,
                            retryDelays: [0, 1000, 3000, 5000],
                        });
                        uppyVOD.upload();
                        
                        this.setState({
                           vodInfo: statusResponse.data
                        });
                    } else {
                        createVideo();
                    }
                
                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function get_status(event_date_id) {
                if (event_type === 'Video On Demand') {
                    return await ApiRequest(`/box-office/video/upload/status?event_date_id=${event_date_id}&type=vod`, {
                        method: 'GET',
                    });
                } else {
                    return await ApiRequest(`/box-office/video/upload/status?event_id=${event_id}&type=scheduled-upload`, {
                        method: 'GET',
                    });
                }
            }

            getVideoStatus();
        } else {
            const token = this.state.token;
            const event_type = this.state.event.event_type;
            
            // Load Event
            const createVideo = async () => {
                try {
                    // Get client events
                    const createResponse = await create_video();
                    console.log('createResponse', createResponse); 
                    
                    if (createResponse.data.vimeo_upload_url) {
                        this.uploadVideo('vod', createResponse.data.vimeo_upload_url)
                        this.setState({
                            vodInfo: createResponse.data
                        });
                    }
                
                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function create_video() {
                return await ApiRequest(`/video/upload/start`, {
                    method: 'POST',
                    data: {
                        upload_token: token,
                        type: event_type === 'Video On Demand' ? 'vod' : 'scheduled-upload',
                        size: vod.size,
                    }
                });
            }

            const getVideoStatus = async () => {
                try {
                    const statusResponse = await get_status(token);
                    console.log('statusResponse', statusResponse);  
                
                    // if url doesn't exist, create the video
                    // if size is not the same as before, create a new video
                    if (statusResponse.data.vimeo_upload_url && statusResponse.data.vimeo_upload_size === vod.size) {
                        uppyVOD.use(Tus, { 
                            uploadUrl: statusResponse.data.vimeo_upload_url,
                            resume: true,
                            autoRetry: true,
                            retryDelays: [0, 1000, 3000, 5000],
                        });
                        uppyVOD.upload();
                        
                        this.setState({
                           vodInfo: statusResponse.data
                        });
                    } else {
                        createVideo();
                    }

                    this.setMessage('', '', '');
                } catch (error) {
                    console.log(error);
                    this.setMessage(window.general_strings.msg.oops, error, 'error');
                }
            };

            async function get_status(token) {
                const type = event_type === 'Video On Demand' ? 'vod' : 'scheduled-upload'
                return await ApiRequest(`/video/upload/status?upload_token=${token}&type=${type}`, {
                    method: 'GET',
                });
            }

            getVideoStatus();
        }
    }

    removeVOD = (id) => {
        uppyVOD.removeFile(id);
        this.setState({
            vod: {},
            isVODUploading: false,
        });
    }

    renderVOD = () => {
        if (this.state.canUploadEventVideo) {
            if (!this.state.vod.name) {
                return (
                    <React.Fragment>
                        <DragDrop
                            uppy={uppyVOD}
                            locale={{
                                strings: {
                                    // Text to show on the droppable area.
                                    // `%{browse}` is replaced with a link that opens the system file selection dialog.
                                    dropHereOr: 'Drop your video here or %{browse}',
                                    // Used as the label for the link that opens the system file selection dialog.
                                    browse: 'browse'
                                }
                            }}
                        />
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <div className="showtix-upload-item">
                            {this.state.isShowUploadMessage && (
                                <div className="showtix-upload-item__loading">
                                    Please wait while your video is processing before being uploaded.
                                </div>
                            )}
                            <div className="showtix-upload-item__name">
                                <button
                                    className="showtix-upload-item__remove"
                                    onClick={() => this.removeVOD(this.state.vod.id)}
                                    disabled={this.state.isVODUploading}
                                >
                                    &times;
                                </button>
                                {this.state.vod.name} - {this.formatBytes(this.state.vod.size)}
                            </div>
                            <button
                                className="showtix-button showtix-background__primary-1"
                                onClick={() => this.uploadVOD()}
                                disabled={this.state.isVODUploading}
                            >
                                Upload
                            </button>
                        </div>
                        <ProgressBar
                            uppy={uppyVOD}
                            fixed
                            hideAfterFinish
                        />
                        <StatusBar
                            uppy={uppyVOD}
                            hideUploadButton
                            hideAfterFinish={false}
                            showProgressDetails
                        />
                    </React.Fragment>
                );
            }
        } else {
            return (
                <div className="showtix-message showtix-message__error is-active">
                    <div className="showtix-padder">
                        <p>Sorry, you need to be 4 hours before your event date to be able to upload.</p>
                    </div>
                </div>
            );
        }
    }
	
    render() {
		return (
            <div className="showtix-section container">
                <div className="row">
                    <div className="col-12">
                        <h1>{strings.title} - {this.state.event.name || ''}</h1>
                        <Message
                            message={this.state.message}
                        />
                        <p className="showtix-subtitle"
                            dangerouslySetInnerHTML={{
                                __html: strings.content
                            }}
                        />

                        <div className="mt-3">
                            <h2>{strings.virtualPoster}</h2>
                            <p dangerouslySetInnerHTML={{
                                __html: strings.sizeVirtualPoster
                            }} />
                            {this.renderVirtualPoster()}
                        </div>
                        
                        {this.state.event_type !== 'Live Stream' && (
                            <div className="mt-3">
                                <h2>{strings.eventVideo}</h2>
                                {this.renderVOD()}
                            </div>
                        )}
                    </div>
                </div> 
            </div>     
		);
  	}
}

export default Upload;



// WEBPACK FOOTER //
// ./src/components/Upload/Upload.js